import PropTypes from "prop-types";
const BlogCard = ({ 
    image, 
    title, 
    excerpt, 
    author, 
    date, 
    readTime, 
    categories 
}) => {
    return (
        <article className="bg-white rounded-lg overflow-hidden shadow-lg h-full flex flex-col">
            <div className="relative pb-[60%] overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="absolute inset-0 w-full h-full object-cover transform transition-transform hover:scale-105"
                />
            </div>
            
            <div className="p-6 flex-1 flex flex-col">
                {categories?.length > 0 && (
                    <div className="flex gap-2 mb-3">
                        {categories.map(category => (
                            <span 
                                key={category}
                                className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full"
                            >
                                {category}
                            </span>
                        ))}
                    </div>
                )}
                
                <h2 className="text-xl font-bold mb-2 line-clamp-2 hover:text-green-600">
                    {title}
                </h2>
                
                {excerpt && (
                    <p className="text-gray-600 mb-4 line-clamp-2">
                        {excerpt}
                    </p>
                )}
                
                <div className="mt-auto">
                    {author && (
                        <div className="flex items-center gap-2 mb-2">
                            <img
                                src={author.avatar || `https://eu.ui-avatars.com/api/?name=${author.name}`}
                                alt={author.name}
                                className="w-8 h-8 rounded-full"
                            />
                            <span className="text-sm font-medium">{author.name}</span>
                        </div>
                    )}
                    
                    <div className="flex items-center justify-between text-sm text-gray-500">
                        <span>{date}</span>
                        {readTime && <span>{readTime}</span>}
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogCard;

BlogCard.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    excerpt: PropTypes.string,
    author: PropTypes.shape({
        name: PropTypes.string,
        avatar: PropTypes.string
    }),
    readTime: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string)
};
